
import L from 'leaflet';

let IconGenerator = (iconPath, size) => {
    return new L.Icon({
        iconUrl: require(`../../assets/imgs/${iconPath}`),
        iconSize: size !== undefined ? size : [20, 20], // size of the icon
        //iconAnchor: [0, 0], // point of the icon which will correspond to marker's location
        //popupAnchor: [0, 0] // point from which the popup should open relative to the iconAnchor
    });
}

export default IconGenerator;